import React from 'react';
import { compose, withHandlers } from 'recompose';

import { WithStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SettingsIcon from '@material-ui/icons/Settings';

import { appName } from '@config/constants';
import { logout } from '@store/auth/auth.actions';
import withNavigation, { WithNavigation } from '@hocs/withNavigation';
import { ProfileRoutePaths } from '@routes/routesPaths';
import { User } from '@api/types.generated';

export interface NavBarProps {}

interface NavBarHandlers {
  homeHandler: () => void;
  profileHandler: () => void;
  logoutHandler: () => void;
}

interface NavBarPrivateProps extends NavBarProps, NavBarHandlers, WithStyles, WithNavigation {
  currentUser: User;
  logoutRequest: typeof logout;
}

const styles = {
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
    cursor: 'pointer',
  },
  settings: {
    cursor: 'pointer',
    marginRight: 15,
  },
  user: {
    marginLeft: -10,
    fontSize: 14,
    cursor: 'pointer',
  },
  menuButton: {
    marginLeft: -10,
    marginRight: 20,
  },
};

const NavBar: React.FunctionComponent<NavBarPrivateProps> = ({
  classes,
  homeHandler,
  profileHandler,
  logoutHandler,
  currentUser,
}) => {
  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          <IconButton onClick={homeHandler} className={classes.menuButton} color="inherit" aria-label="Menu">
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" color="inherit" className={classes.title} onClick={homeHandler}>
            {appName}
          </Typography>
          <SettingsIcon onClick={profileHandler} className={classes.settings} />
          <Typography variant="h6" color="inherit" className={classes.user} onClick={profileHandler}>
            {currentUser.name}
          </Typography>
          <Button color="inherit" onClick={logoutHandler}>
            <ExitToAppIcon />
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default compose<NavBarPrivateProps, NavBarProps>(
  withNavigation,
  withStyles(styles),
  withHandlers<NavBarPrivateProps, NavBarHandlers>({
    homeHandler: ({ goHome }) => () => {
      goHome();
    },
    profileHandler: ({ goTo }) => () => {
      goTo(ProfileRoutePaths.profileRoot);
    },
    logoutHandler: ({ logoutRequest }) => () => {
      logoutRequest({});
    },
  }),
)(NavBar);
